const ChargeableWeightBifurcationType = {
  LR_NUMBER: 'LR_NUMBER',
  INDENT: 'INDENT',
};

module.exports = {
  ChargeableWeightBifurcationType,
};
